/**
 * 회원 화면 공통 코드 라벨
 *
 *  값은 INFO_USER.CD_USER_TYPE / CD_SNS_TYPE (백엔드 UserTypeEnum / SnsTypeEnum) 과 동일하다.
 *
 *  참고: INFO_USER 는 보호자 전용 테이블이다. 회원가입이 USER_TYPE_PET_OWNER 외에는
 *  거부되고(UserAuthServiceImpl), 사업자·선생님 계정은 INFO_BUSINESS_USER 에 저장된다.
 *  따라서 회원 목록의 탭은 유형이 아니라 가입 경로(SNS) 기준으로 나눈다.
 */
import type { MemberSnsTypeCode } from '@/services/api';

export const MEMBER_TYPE_LABEL: Record<string, string> = {
  USER_TYPE_PET_OWNER: '보호자',
  USER_TYPE_OWNER: '사업자',
  USER_TYPE_TEACHER: '선생님',
};

export const SNS_LABEL: Record<string, string> = {
  SNS_TYPE_KAKAO: '카카오',
  SNS_TYPE_NAVER: '네이버',
  SNS_TYPE_GOOGLE: '구글',
  SNS_TYPE_APPLE: '애플',
};

/** 목록 상단 가입 경로 탭 */
export const SNS_TABS: { key: 'ALL' | MemberSnsTypeCode | 'TEST'; label: string }[] = [
  { key: 'ALL', label: '전체' },
  { key: 'SNS_TYPE_KAKAO', label: '카카오' },
  { key: 'SNS_TYPE_NAVER', label: '네이버' },
  { key: 'SNS_TYPE_GOOGLE', label: '구글' },
  { key: 'SNS_TYPE_APPLE', label: '애플' },
  { key: 'TEST', label: '테스트' },
];
